// Helper de autenticação compartilhado. Pega o idToken Cognito da sessão atual.
//
// Antes essa função estava duplicada (cópia idêntica) em 41+ páginas do frontend.
// Migração gradual: novos arquivos importam daqui; arquivos legados podem
// continuar com a função local até serem revisitados (find/replace em massa
// tem risco médio porque várias páginas usam `fetchAuthSession` pra outros
// fins além do idToken).
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Retorna o idToken JWT do Cognito como string.
 * Vazio se não houver sessão.
 *
 * Uso:
 *   const token = await getToken();
 *   axios.get(url, { headers: { Authorization: token } });
 */
export async function getToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}
